(function Module() {
	'use strict';

	var mySynchModules = require('../config');

	mySynch.factory('ApiBase', [
		'CookieFactory',
		function apiBase(cookies) {
			var apiServerUrl = mySynchModules.config.apiServer.hostname + ':' + mySynchModules.config.apiServer.port;

			function callbackOrLog(callback, err, data) {
				if (_.isFunction(callback)) {
					callback(err, data);
				} else {
					if (err) {
						console.log('unhandled api response with error', {err: err});
					} else if (_.isNull(data)) {
						console.log('unhandled api response with null data', {data: data});
					} else {
						console.log('unhandled api response with data', {data: data});
					}
				}
			}

			function processHeaders(headers, alwaysAllow) {
				if (headers('x-mysynch-user-bearer') && (!_.isEmpty(cookies.user) || alwaysAllow)) {
					cookies.user.token = headers('x-mysynch-user-bearer');

					try {

						var tokenParts = cookies.user.token.split('|');
						var expiryDate;
						if(tokenParts.length == 3){
							expiryDate = tokenParts[2];
							//console.log("######### User was using old token format  in processHeaders #########");
						}else{
							expiryDate = tokenParts[3];
							//console.log("######### User was using new token format  in processHeaders #########");
						}
						if (Number(expiryDate) <= +moment()) {
							delete cookies.user.token;
							cookies.save();
						}
					}catch (e) {
						// disregard errors
						console.error("process header error: "+e);
					}
				}

				cookies.save();
			}

			function sendHeaders(perfContext = null) {
				var headers = {};

				if (cookies.user && cookies.user.token) {
					headers['x-mysynch-user-bearer'] = cookies.user.token;
				}

				if (perfContext) {
					headers['x-mysynch-perf-context'] = JSON.stringify(perfContext);
				}

				return {headers: headers};
			}

			function getUserToken() {
				return cookies.user.token;
			}


			function cacheBust(url) {
				var workingUrl		= String(url);
				var queryBeginsAt	= workingUrl.indexOf('?');
				var hashBeginsAt	= workingUrl.indexOf('#');

				var base	= '';
				var query	= '';
				var hash	= '';

				if (queryBeginsAt > -1) {
					base = workingUrl.substr(0, queryBeginsAt);

					if (hashBeginsAt > -1) {
						query	= workingUrl.substr(queryBeginsAt, hashBeginsAt - queryBeginsAt);
						hash	= workingUrl.substr(hashBeginsAt);
					} else {
						query	= workingUrl.substr(queryBeginsAt);
					}
				} else if (hashBeginsAt > -1) {
					base = workingUrl.substr(0, hashBeginsAt);
					hash = workingUrl.substr(hashBeginsAt);
				} else {
					base = workingUrl;
				}

				if (query) {
					query = query + '&_=' + new Date().getTime();
				} else {
					query = query + '?_=' + new Date().getTime();
				}

				return base + query + hash;
			}

			function prepareUrl(path) {
				return cacheBust(apiServerUrl + path);
			}
            // params should be an object 
			function  buildUrlWithParams(url,params){
                
				if(_.isUndefined(params) || _.isEmpty(params) || _.isArray(params)){
					return url;
				}else{
					var keys = _.keys(params);

					var hasInitialParams = _.contains(url,"?");

					if(!hasInitialParams) 
					{
						url += "?";
					}
					_.forEach(keys,function (key,index) {
						if(index == 0){
							if(hasInitialParams){
								url += "&"+key+"="+_.get(params,key);	
							}else{
								url += key+"="+_.get(params,key);
							}
							
						}else{
							url += "&"+key+"="+_.get(params,key);
						}
						
					});
					return url;
				}
				
				
				
			}

			function lowerCaseObjectKeys(obj) {
				if (!_.isObject(obj)) {
					return obj;
				}

				return _.reduce(obj, function reduceToAnObjectLowerCaseKeys(result, value, key) {
					key = key.charAt(0).toLowerCase() + key.slice(1);
					result[key] = value;

					return result;
				}, {});
			}
			

			function lowerCaseObjectOfCollections(objOfCollections) {
				return _.forOwn(objOfCollections, function eachList(listArray, listKey) {
					objOfCollections[listKey] = _.map(listArray, lowerCaseObjectKeys);
				});
			}

			function lowerCaseObjectOfObjsAndCollections(obj) {
				_.forEach(_.keys(obj), function (key) {
				
						var property = obj[key];

						if (_.isArray(property)) {
							obj[key] = _.map(property,lowerCaseObjectKeys);
						}else if(_.isObject(property)) {
							obj[key] = lowerCaseObjectKeys(property);
						}

				    }
				);
		
				return lowerCaseObjectKeys(obj);
			}

			function upperCaseObjectKeys(obj) {
				if (!_.isObject(obj)) {
					return obj;
				}

				return _.reduce(obj, function reduceToAnObjectLowerCaseKeys(result, value, key) {
					key = key.charAt(0).toUpperCase() + key.slice(1);
					result[key] = value;

					return result;
				}, {});
			}

			function upperCaseObjectOfCollections(objOfCollections) {
				return _.forOwn(objOfCollections, function eachList(listArray, listKey) {
					objOfCollections[listKey] = _.map(listArray, upperCaseObjectKeys);
				});
			}

			return {
				apiServerUrl: apiServerUrl,
				callbackOrLog: callbackOrLog,
				processHeaders: processHeaders,
				sendHeaders: sendHeaders,
				getUserToken: getUserToken,
				prepareUrl: prepareUrl,
				buildUrlWithParams: buildUrlWithParams,
				lowerCaseObjectKeys: lowerCaseObjectKeys,
				lowerCaseObjectOfCollections: lowerCaseObjectOfCollections,
				lowerCaseObjectOfObjsAndCollections: lowerCaseObjectOfObjsAndCollections,
				upperCaseObjectKeys: upperCaseObjectKeys,
				upperCaseObjectOfCollections : upperCaseObjectOfCollections
			};
		}
	]);
})();
